export default __webpack_public_path__ + "27b7f6328248748c1cc80f1f3839258d.svg";